import { FavoriteCollectionService, FavoriteLibService } from '@aipb/personal-content/data-access';
import { CreateEditNibbleDialogService } from '@aipb/personal-content/dialog';
import { UseCase } from '@aipb/util/usecase';
import { inject, Injectable } from '@angular/core';
import { mergeMap } from 'rxjs';

interface AddAfterDto {
  position: number;
  collectionId: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddAfterUseCase implements UseCase<AddAfterDto> {
  private createEditNibbleDialogService = inject(CreateEditNibbleDialogService);
  private favoriteCollectionService = inject(FavoriteCollectionService);
  private favoriteLibService = inject(FavoriteLibService);

  execute(data: AddAfterDto): void {
    this.createEditNibbleDialogService
      .open$({
        collectionId: data.collectionId,
        position: data.position + 1
      })
      .pipe(mergeMap(() => this.favoriteCollectionService.get(data.collectionId, 'on')))
      .subscribe(() => {
        this.favoriteLibService.refreshPlugin();
      });
  }
}
